<template>
  <div class="example">
    <toptitle :title1="titlework" />
    <!-- <section class="provesec">
      <div>
        <span>序号</span>
      </div>
      <div class="arrow">
        <van-cell is-link>{{ word1 }}</van-cell>
      </div>
    </section> -->
    <van-cell-group>
      <van-field required
                 v-model="name"
                 label="姓名"
                 placeholder="请输入" />
    </van-cell-group>
    <section class="provesec">
      <div>
        <span>性别</span>
      </div>
      <div class="arrow">
        <van-cell is-link
                  @click="showPopup3">{{ sex }}</van-cell>
        <van-popup v-model="show3">
          <van-picker title="请选择"
                      show-toolbar
                      :columns="columns3"
                      @confirm="onConfirm3"
                      @cancel="onCancel" />
        </van-popup>
      </div>
    </section>
    <section class="provesec">
      <div class="star">
        <span class="star1">*</span>
        <span>成员关系</span>
      </div>
      <div class="arrow">
        <van-cell is-link
                  @click="showPopup2">{{ word2 }}</van-cell>
        <van-popup v-model="show2">
          <van-picker title="请选择关系"
                      show-toolbar
                      :columns="columns2"
                      @confirm="onConfirm2"
                      @cancel="onCancel" />
        </van-popup>
      </div>
    </section>
    <section class="provesec">
      <div>
        <span>婚姻状况</span>
      </div>
      <div class="arrow">
        <van-cell is-link
                  @click="showPopup4">{{ marry }}</van-cell>
        <van-popup v-model="show4">
          <van-picker title="请选择"
                      show-toolbar
                      :columns="columns4"
                      @confirm="onConfirm4"
                      @cancel="onCancel" />
        </van-popup>
      </div>
    </section>
    <section class="provesec">
      <div>
        <span>政治面貌</span>
      </div>
      <div class="arrow">
        <van-cell is-link
                  @click="showPopup5">{{ face }}</van-cell>
        <van-popup v-model="show5">
          <van-picker title="请选择"
                      show-toolbar
                      :columns="columns5"
                      @confirm="onConfirm5"
                      @cancel="onCancel" />
        </van-popup>
      </div>
    </section>
    <van-cell-group style="margin-top: 10px">
      <van-field v-model="phone"
                 label="联系电话"
                 placeholder="请输入手机号" />
      <van-field v-model="position"
                 label="职务"
                 placeholder="请输入" />
      <van-field v-model="post"
                 label="邮编"
                 placeholder="请输入" />
      <van-cell title="出生日期"
                is-link
                :value="birthday"
                @click="keyboard" />
      <section class="provesec">
        <div>
          <span>证件类型</span>
        </div>
        <div class="arrow">
          <van-cell is-link
                    @click="showPopup6">{{ type }}</van-cell>
          <van-popup v-model="show6">
            <van-picker title="请选择序号"
                        show-toolbar
                        :columns="columns6"
                        @confirm="onConfirm6"
                        @cancel="onCancel" />
          </van-popup>
        </div>
      </section>
      <van-field v-model="SPECIAL_CHAR"
                 label="证件号码"
                 placeholder="请输入" />
    </van-cell-group>
    <p class="blank">居住地址</p>
    <van-field v-model="address"
               rows="1"
               autosize
               type="textarea" />
    <p class="blank">工作单位</p>
    <van-field style="margin-bottom: 60px"
               v-model="workplace"
               rows="1"
               autosize
               type="textarea" />
    <div class="button-bt">
      <div @click="submit">提交</div>
      <div @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import toptitle from '../../components/toptitle'
import { changeDataApi, changeResumeDataApi } from '../../request/api'
import * as dd from 'dingtalk-jsapi' // 此方式为整体加载，也可按需进行加载
export default {
  data() {
    name: 'example'
    return {
      titlework: '编辑家庭信息',
      show: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      columns: [],
      columns1: [],
      columns2: [],
      columns3: ['男', '女'],
      columns4: ['未婚', '已婚未育', '已婚已育', '离异', '丧偶'],
      columns5: [],
      columns6: [],
      name: this.$route.query.C_RELATED_NAME,
      word1: this.$route.query.C_SEQUENCE_NUM
        ? this.$route.query.C_SEQUENCE_NUM
        : '0',
      word2: this.$route.query.C_RELATIONGSHIP,
      phone: this.$route.query.C_RELATED_PHONE,
      position: this.$route.query.C_RELATED_CAREER,
      address: this.$route.query.C_RELATED_ADDR,
      workplace: this.$route.query.C_RELATED_COMPANY,
      sex: this.$route.query.SEX,
      post: this.$route.query.C_POSTCODE,
      marry: this.$route.query.MAR_STATUS,
      face: this.$route.query.POLITICAL_STA_CHN,
      birthday: this.$route.query.BIRTHDATE,
      SPECIAL_CHAR: this.$route.query.NID_SPECIAL_CHAR,
      type: this.$route.query.C_NID_TYPE,
      faceArr: [],
      typeArr: [],
      currentTime: '',
    }
  },
  methods: {
    showPopup2() {
      this.show2 = true
    },
    showPopup3() {
      this.show3 = true
    },
    showPopup4() {
      this.show4 = true
    },
    showPopup5() {
      this.show5 = true
    },
    showPopup6() {
      this.show6 = true
    },
    onConfirm2(value) {
      this.word2 = value
      this.show2 = false
    },
    onConfirm3(value) {
      this.sex = value
      this.show3 = false
    },
    onConfirm4(value) {
      this.marry = value
      this.show4 = false
    },
    onConfirm5(value) {
      this.face = value
      this.show5 = false
    },
    onConfirm6(value) {
      this.type = value
      this.show6 = false
    },
    onCancel() {
      this.show2 = false
      this.show3 = false
      this.show4 = false
      this.show5 = false
      this.show6 = false
    },
    keyboard() {
      let that = this
      dd.biz.util.datepicker({
        format: 'yyyy-MM-dd',
        value: '2020-11-27',
        onSuccess: function (result) {
          that.birthday = result.value
        },
        onFail: function (err) {},
      })
    },
    cancel() {
      this.$router.push('/resume')
    },
    submit() {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (this.phone) {
        if (!regMobile.test(this.phone)) {
          Toast.fail('手机号码格式不正确')
          return
        }
      }
      if (!this.name) {
        Toast.fail('请填写姓名')
        return
      }
      // if (!this.sex) {
      //   Toast.fail("请填写性别");
      //   return;
      // }
      if (!this.word2) {
        Toast.fail('请填写关系')
        return
      }
      // if (!this.marry) {
      //   Toast.fail("请填写婚姻状况");
      //   return;
      // }
      // if (!this.face) {
      //   Toast.fail("请填写政治面貌");
      //   return;
      // }
      // if (!this.SPECIAL_CHAR) {
      //   Toast.fail("请填写证件号码");
      //   return;
      // }
      let marry = ''
      if (this.marry == '离异') {
        marry = 'D'
      } else if (this.marry == '已婚未育') {
        marry = 'M'
      } else if (this.marry == '未婚') {
        marry = 'S'
      } else if (this.marry == '已婚已育') {
        marry = 'Z'
      } else if (this.marry == '丧偶') {
        marry = 'W'
      } else {
        marry = ''
      }
      let face = ''
      this.faceArr.forEach((element) => {
        if (this.face == element.XLATSHORTNAME) {
          face = element.FIELDVALUE
        }
      })
      let relation = ''
      this.columns1.forEach((element) => {
        if (this.word2 == element.XLATSHORTNAME) {
          relation = element.FIELDVALUE
        }
      })
      let type = ''
      this.typeArr.forEach((element) => {
        if (this.type == element.XLATSHORTNAME) {
          type = element.FIELDVALUE
        }
      })
      let sex = ''
      if (this.sex == '男') {
        sex = 'M'
      } else if (this.sex == '女') {
        sex = 'F'
      } else {
        sex = ''
      }
      let params = {
        security: {
          signTxt: 'OTQ5QKE3NJJFNDQ0Q0JFM0JDNURDNJM2MTG4NKIWQJM3=',
          ipAddress: '10.19.185.14',
          system: 'SELF',
          pubkeyRmk: 'Z7PCKFDMBPVHGS0ZGDQT',
        },
        parameters: {
          TYPE: '3',
          C_SEQUENCE_NUM: this.word1,
          EMPLID: sessionStorage.getItem('EMPLID'),
          DATE: this.currentTime,
          C_RELATIONGSHIP_ID: relation,
          C_RELATED_NAME: this.name,
          C_NID_TYPE_ID: type,
          NID_SPECIAL_CHAR: this.SPECIAL_CHAR ? this.SPECIAL_CHAR : '',
          SEX_ID: sex,
          BIRTHDATE: this.birthday ? this.birthday : '',
          C_RELATED_PHONE: this.phone ? this.phone : '',
          MAR_STATUS_ID: marry,
          POLITICAL_STA_CHN_ID: face,
          BIRTHCOUNTRY_ID: 'CHN',
          C_RELATED_ADDR: this.address ? this.address : '',
          C_POSTCODE: this.post ? this.post : '',
          C_RELATED_COMPANY: this.workplace ? this.workplace : '',
          C_RELATED_CAREER: this.position ? this.position : '',
        },
      }
      changeResumeDataApi(params).then((res) => {
        console.log(res)
        if (res.CODE == 1) {
          Toast.success('提交成功')
          this.$router.back(-1)
        } else {
          Toast.fail(res.MESSAGE)
        }
      })
    },
  },
  components: {
    toptitle,
  },
  created() {
    var s = new Date()
    var m = s.getMonth() + 1
    var d = s.getDate()
    if (m >= 1 && m <= 9) {
      m = '0' + m
    }
    if (d >= 0 && d <= 9) {
      d = '0' + d
    }
    this.currentTime = s.getFullYear() + '-' + m + '-' + d
    let params = { FIELDNAME: 'C_RELATIONGSHIP' }
    let params1 = { FIELDNAME: 'POLITICAL_STA_CHN' }
    let params2 = { FIELDNAME: 'C_NID_TYPE' }
    changeDataApi(params1).then((res) => {
      if (res.RESULTCODE == 1) {
        this.faceArr = res.DATA
        this.columns5 = this.faceArr.map((index) => {
          return index.XLATSHORTNAME
        })
      }
    })
    changeDataApi(params).then((res) => {
      this.columns1 = res.DATA
      this.columns2 = this.columns1.map((index) => {
        return index.XLATSHORTNAME
      })
    })
    changeDataApi(params2).then((res) => {
      if (res.RESULTCODE == 1) {
        this.typeArr = res.DATA
        this.columns6 = this.typeArr.map((index) => {
          return index.XLATSHORTNAME
        })
      }
    })
  },
}
</script>

<style lang="less" scoped>
.provesec {
  display: flex;
  line-height: 44px;
  background: white;
  padding-left: 16px;
  .arrow {
    flex: 1;
    text-align: right;
    line-height: 44px;
    color: #c4c4c6;
  }
  .star {
    position: relative;
    left: -8px;
    .star1 {
      color: red;
      font-size: 14px;
    }
  }
}
/deep/ .van-cell__value {
  text-align: right;
}
/deep/ .van-popup {
  width: 80%;
}
/deep/ .van-cell__title {
  font-size: 16px;
  color: black;
}
/deep/ input.van-field__control {
  text-align: right;
}
.blank {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  padding: 0 16px;
  color: #888888;
}
.button-bt {
  position: fixed;
  bottom: 0;
  display: flex;
  line-height: 44px;
  text-align: center;
  color: white;
  width: 100%;
  div {
    background: #733e2a;
    width: 50%;
    font-size: 17px;
  }
}
</style>
